import { OrganizationCalendarI } from '@interfaces/organizationI';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const organizationsSlice = createSlice({
    name: 'organizations',
    initialState:  {
        organizationId: 0,
        organizationName: '',
        predetermined: false,
        predeterminedDrProx: false,
        organizationType: null,
        roles: [],
        statusCode: undefined,
        usernameSA: undefined
    } as OrganizationCalendarI ,
    reducers: {
        setOrganization: (state, action: PayloadAction<OrganizationCalendarI>) => {
            state.organizationId = action.payload.organizationId;
            state.organizationName = action.payload.organizationName;
            state.predetermined = action.payload.predetermined;
            state.predeterminedDrProx = action.payload.predeterminedDrProx;
            state.organizationType = action.payload.organizationType;
            state.organizationType = action.payload.organizationType;
            state.usernameSA = action.payload.usernameSA;
            state.roles = action.payload.roles;
        },
        cleanOrganizationDefault: (state) => {
            state.organizationId = 0;
            state.organizationName = "";
            state.predetermined = false;
            state.predeterminedDrProx = false;
            state.organizationType = null;
        },
    },
});

export const { setOrganization,cleanOrganizationDefault } = organizationsSlice.actions;
export default organizationsSlice.reducer;
